import type { TabsDesignTokens } from '@primeuix/themes/types/tabs'

import { bothSchemes } from '../utils'

/**
 * Табы «Активные / Завершённые» в истории заказов и
 * «Новости / Акции» в уведомлениях. Индикатор — жёлтый, 2px.
 */
export const tabsConfig = (): TabsDesignTokens => ({
  tablist: {
    borderWidth: '0 0 1px 0',
  },
  tab: {
    borderWidth: '0 0 2px 0',
    padding: 'var(--space-6) 0',
    fontWeight: 'var(--fw-bold)',
    gap: 'var(--space-4)',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  tabpanel: {
    padding: 'var(--space-8) 0 0',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  navButton: {
    width: '2rem',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  activeBar: {
    height: '2px',
    bottom: '-1px',
  },
  colorScheme: bothSchemes({
    tablist: {
      background: 'transparent',
      borderColor: 'var(--border-color)',
    },
    tab: {
      background: 'transparent',
      hoverBackground: 'transparent',
      activeBackground: 'transparent',
      borderColor: 'transparent',
      hoverBorderColor: 'transparent',
      activeBorderColor: 'var(--accent-500)',
      color: 'var(--text-color-secondary)',
      hoverColor: 'var(--text-color)',
      activeColor: 'var(--text-color)',
    },
    tabpanel: {
      background: 'transparent',
      color: 'var(--text-color)',
    },
    navButton: {
      background: 'var(--surface-card)',
      color: 'var(--text-color)',
    },
    activeBar: {
      background: 'var(--accent-500)',
    },
  }),
})
